import {
	subDays,
	addDays,
	startOfDay,
	format,
	endOfDay,
	endOfWeek,
	intervalToDuration,
	differenceInDays
} from 'date-fns';
import _ from 'underscore';
import ruLocale from 'date-fns/locale/ru';
import { getNumericDeclension } from '@culture/common-helpers/string';

const getDateAriaLabel = (when) => `Выбор трансляций ${when}`;

const dateHash = {
	yesterday: {
		title: 'Вчера',
		ariaLabel: getDateAriaLabel('на вчера'),
		values: () => ({
			startDate: format(startOfDay(subDays(new Date(), 1)), 'yyyy-MM-dd'),
			endDate: format(endOfDay(subDays(new Date(), 1)), 'yyyy-MM-dd')
		})
	},
	today: {
		title: 'Сегодня',
		ariaLabel: getDateAriaLabel('на сегодня'),
		values: () => ({
			startDate: format(startOfDay(new Date()), 'yyyy-MM-dd'),
			endDate: format(endOfDay(new Date()), 'yyyy-MM-dd')
		})
	},
	tomorrow: {
		title: 'Завтра',
		ariaLabel: getDateAriaLabel('на завтра'),
		values: () => ({
			startDate: format(startOfDay(addDays(new Date(), 1)), 'yyyy-MM-dd'),
			endDate: format(endOfDay(addDays(new Date(), 1)), 'yyyy-MM-dd')
		})
	},
	weekends: {
		title: 'Выходные',
		ariaLabel: getDateAriaLabel('в выходные дни'),
		values: () => ({
			startDate: format(
				startOfDay(subDays(endOfWeek(new Date(), { locale: ruLocale }), 1)),
				'yyyy-MM-dd'
			),
			endDate: format(
				endOfDay(endOfWeek(new Date(), { locale: ruLocale })),
				'yyyy-MM-dd'
			)
		})
	}
};

export const formatDuration = (startDate, endDate, options = {}) => {
	const extendedOptions = {
		formatList: ['д', 'ч', 'м'],
		withZeros: false,
		...options
	};
	const interval = intervalToDuration({ start: startDate, end: endDate });

	return [
		differenceInDays(startDate, endDate),
		interval.hours,
		interval.minutes
	]
		.reduce((memo, num, index) => {
			if (num || extendedOptions.withZeros) {
				memo.push(`${num} ${extendedOptions.formatList[index]}`);
			}

			return memo;
		}, [])
		.join(' : ');
};

export const getIntervalStringFromInterval = (
	interval,
	periodsToPick = ['days', 'hours', 'minutes']
) => {
	const periodTitleHash = {
		years: {
			single: 'год',
			some: 'года',
			many: 'лет'
		},
		months: {
			single: 'месяц',
			some: 'месяца',
			many: 'месяцев'
		},
		days: {
			single: 'день',
			some: 'дня',
			many: 'дней'
		},
		hours: {
			single: 'час',
			some: 'часа',
			many: 'часов'
		},
		minutes: {
			single: 'минута',
			some: 'минуты',
			many: 'минут'
		},
		seconds: {
			single: 'секунда',
			some: 'секунды',
			many: 'секунда'
		}
	};
	const pickedData = _(interval).pick(periodsToPick);

	const stringInterval = Object.entries(pickedData)
		.map(
			([key, value]) =>
				`${value} ${getNumericDeclension(value, periodTitleHash[key])}`
		)
		.join(' ');

	return stringInterval;
};

export default {
	dateHash
};
